export const toSet = <T extends unknown[]>(source: T) => [...new Set(source)] as T;
